import { Theme, createStyles } from "@material-ui/core/styles";
import { drawerWidth } from "./layout/helpers";

const stylesFunc = (theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    appBar: {
      backgroundColor: "#324257",
      color: "white",
      [theme.breakpoints.up("md")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    appBarFull: {
      backgroundColor: "#324257",
      color: "white",
      width: "100%",
      marginLeft: 0,
    },
    grow: {
      flexGrow: 1,
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    sectionMobile: {
      display: "flex",
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
  });

export default stylesFunc;
